import NavbarMenu from "./NavbarMenu";

export default NavbarMenu;
